import gettext from '@eb/gettext';
import { makeValidator, joinValidators } from '@eb/eds-utils';
import { constants } from '@eb/event-create-publish-utils';

import { isProvided } from '@eb/validators';
import { CUSTOM_MESSAGE_MAX_LENGTH } from './constants';

const { DISPLAY_SALES_STATUS_CUSTOM } = constants;

const fieldValidator = makeValidator({
    statusCode: [
        {
            validator: isProvided,
            errorMessage: gettext('Status is required.'),
        },
    ],
});

const customMessageValidator = ({ statusCode, customMessage }) => {
    let errors = {};

    if (statusCode === DISPLAY_SALES_STATUS_CUSTOM) {
        if (!customMessage) {
            errors = {
                customMessage: gettext('Custom message is required.'),
            };
        } else if (customMessage.length > CUSTOM_MESSAGE_MAX_LENGTH) {
            errors = {
                customMessage: gettext(
                    'Custom message must be %(maxLength)s characters or less.',
                    {
                        maxLength: CUSTOM_MESSAGE_MAX_LENGTH,
                    },
                ),
            };
        }
    }

    return errors;
};

export default joinValidators(fieldValidator, customMessageValidator);
